import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import { WidgetModule } from '../../../widget/widget.module';
import { UpgradeMessageComponent } from '../../../upgrade-message/upgrade-message.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { B2BNetworkcardComponent } from '../../../components/cards/b2bnetwork-card/b2bnetwork-card.component';
import { FilterPipe } from '../../../pipe/SearchFilter/filter.pipe';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

@Component({
  selector: 'app-b2b-network-connection',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, InfiniteScrollModule,
WidgetModule, UpgradeMessageComponent, NodataFoundComponent, CommonSkeletonComponent, B2BNetworkcardComponent, FilterPipe,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './b2b-network-connection.component.html',
  styleUrls: ['./b2b-network-connection.component.scss']
})
export class B2bNetworkConnectionComponent {
  userType: any = localStorage.getItem('userType');
  uesrId=localStorage.getItem('userId');
  page: string = 'landingpage';
  membershipType=localStorage.getItem('MemberShipType');
  searchKey
  stopScroll:boolean=false
  activeNetwork: boolean = false;
  noDatafound: Array<string>;
  loadAPIcall:boolean=false;
  status = null;
  count: number = 0;
  btnnameshow: any;
  connect: boolean = false;
  allConnect: boolean = true;
  requestsent: boolean = false;
  requestrecived: boolean = false;
  searchContent:string="";
  role:any
  prevAfterkey = null;
  businessDetails:any
  showNoDatafound: boolean = false;
  searchSubject = new Subject<string>();
  connectionlistuserdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  params = {
    page: 0,
    limit: 10,
    businessId:null,
    searchAfterKey: null,
    status:this.status,
    searchContent: "",
  };


  constructor(
    private api: ApiService,
    private util: UtilService,



  ) { }
  ngOnInit() {
    this.getbusinessId()
  }

  onScrollDown() {
    if (this.prevAfterkey!==undefined&&JSON.stringify(this.params.searchAfterKey) !== JSON.stringify(this.prevAfterkey)) {
      this.params.searchAfterKey = (this.prevAfterkey && this.prevAfterkey.length === 0) ? null : this.prevAfterkey;
      this.b2bnetworklist(this.status, null);
    }
  }

  businessId:any
  getbusinessId(){
    const userId = localStorage.getItem('userId');
    this.api.query(`business/findUserRoleInBusiness/${userId}`).subscribe(response => {
      if(response.data!=null){
        this.businessId = response.data&&response.data.businessData.businessId;
        this.role = response.data.role;
        this.businessDetails = {
          ...this.businessDetails, // Keep existing details
          id: response.data.businessData.businessId,
          businessEmail: response.data.businessData.businessEmail,
          businessName: response.data.businessData.businessName,
          bid: response.data.businessData.platformBusinesId,
          plan: response.data.businessData.subscriptionType
        };
        this.b2bnetworklist(this.status,null);
        this.searchSubject.pipe(
          debounceTime(1500),
          distinctUntilChanged()
        )
          .subscribe(
            res => {
              this.updateSearch();
            }
          )

      }

    });
  }
  updateSearch() {
    this.params.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.params.searchAfterKey = null;
    this.count = 0;
    this.stopScroll = false;
    this.connectionlistuserdata.next([]); // Clearing old data
    this.b2bnetworklist(this.status,null); // Fetching new data
  }


  filterstatus(filter, status?: string){
    this.params.searchAfterKey=null;
    this.params.searchContent="";
    this.searchContent = ''; // Clear the searchContent value
    this.count=0
    this.stopScroll=false
    this.connectionlistuserdata.next([]);
    this.b2bnetworklist(filter,null);
  }
  keyupdata(value : string) {
    this.searchSubject.next(value);
}


  b2bnetworklist(filter, action) {
    this.loadAPIcall = true;
    let noData = [];
    this.params.status = filter;
    this.status = filter;


    if (this.status === 'CONNECTED') {
        noData = this.searchContent !== "" ? ['No data available!'] : ['No active contacts'];
        this.btnnameshow = 'Active Contacts';
        this.connect = true;
        this.requestsent = false;
        this.requestrecived = false;
        this.allConnect = false;
    } else if (this.status === 'REQUEST_RECEIVED') {
        noData = this.searchContent !== "" ? ['No data available!'] : ['No contacts requests received'];
        this.btnnameshow = 'Requests Received';
        this.connect = false;
        this.requestsent = false;
        this.requestrecived = true;
        this.allConnect = false;
    } else if (this.status === 'REQUEST_SENT') {
        noData = this.searchContent !== "" ? ['No data available!'] : ['No contacts request sent'];
        this.btnnameshow = 'Requests Sent';
        this.allConnect = false;
        this.connect = false;
        this.requestsent = true;
        this.requestrecived = false;
    } else if (this.status === null && action !== 'remove') {
        noData = ['You do not have business contacts yet.'];
        this.btnnameshow = 'All';
        this.allConnect = true;
        this.connect = false;
        this.requestsent = false;
        this.requestrecived = false;
    } else if (this.searchContent !== "") {
        noData = ['No data available!'];
    }

    this.util.startLoader();
    this.params.businessId = this.businessId;

    this.api.create('business/findB2BContactsList', this.params).subscribe(res => {
      if(res) {
        this.util.stopLoader();
      }
        this.loadAPIcall = false;

        let data = res.data&&res.data.b2bContacts;
        if (data != null) {
            const resData = data;
            const afterKey = res.data && res.data.searchAfterKey;

            if (JSON.stringify(this.prevAfterkey) === JSON.stringify(afterKey)|| resData.length === 0) {
              this.stopScroll = true;
            }
            this.prevAfterkey = afterKey;

            if (resData.length > 0) {
                const existingData = this.connectionlistuserdata.getValue();


                const uniqueEntries = new Set(existingData.map(item => JSON.stringify(item)));


                resData.forEach(newItem => {
                    const stringifiedNewItem = JSON.stringify(newItem);
                    if (!uniqueEntries.has(stringifiedNewItem)) {
                        uniqueEntries.add(stringifiedNewItem);
                    }
                });


                const combined = Array.from(uniqueEntries).map(item => JSON.parse(item));
                this.connectionlistuserdata.next(combined);

            }

            // Handle total count and no data found case
            if (res.data.total !== undefined) {
                this.count = res.data.total;
            }

            this.showNoDatafound = this.connectionlistuserdata.getValue().length === 0;
            this.noDatafound = this.showNoDatafound ? noData : [];
        }
    }, error => {
        this.util.stopLoader();
        this.showNoDatafound = true;
        this.noDatafound = ['An error occurred. Please try again later.'];
    });
}


  refreshBusinessNetworkList(eventData: { value: any, action: string }) {
    const { value, action } = eventData;
    this.stopScroll=false
    this.params.searchAfterKey = null;
    this.prevAfterkey = null;
    this.connectionlistuserdata.next([]);
    this.b2bnetworklist(this.status, action);
  }

}


